/**
 * FullCalendar v7 shared setup (theme + Premium scheduler plugins).
 *
 * Styles must be imported once (side-effect). Classic theme is the closest
 * visual match to FullCalendar v6; fullCalendarCompat re-injects legacy
 * class names + baseline layout for existing Schedule/GameMaster SCSS.
 */
import '@fullcalendar/react/skeleton.css';
import '@fullcalendar/react/themes/classic/theme.css';
import '@fullcalendar/react/themes/classic/palette.css';
import './fullCalendarCompat.css';

import themePlugin from '@fullcalendar/react/themes/classic';
import interactionPlugin from '@fullcalendar/react/interaction';
import resourceTimelinePlugin from '@fullcalendar/react-scheduler/resource-timeline';

export { FULLCALENDAR_LICENSE_KEY } from './fullCalendarLicense';

export const fullCalendarPlugins = [themePlugin, interactionPlugin, resourceTimelinePlugin];
